import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/20/solid";
import React, { useEffect, useMemo } from "react";
import { connect } from "react-redux";
import Spinner from "../../common/Spinner";
import { Actions as ACCOUNTING_INTEGRATION_ACTIONS } from "./store/accountingIntegrationActions";
import { toTitleCase } from "@/common/validation/Validators";
import { camelCase } from "lodash";
import Tooltip from "@/common/tooltip/Tooltip";

const AccountingIntegrationSendData = ({
	integration,
	periodId,
	sendPayPeriodToAccountingIntegration,
	getPayPeriodStatus,
	logo,
	sending,
	status,
	errors,
	connected,
	complete,
	functionality,
	toggleErrorsModal,
}) => {
	const icon = useMemo(() => {
		if (sending || status === "pending")
			return (
				<Spinner
					style={{ color: "green", width: 12, position: "relative", top: -8, right: -14 }}
					className="animate-spin -ml-1 mr-3"
				/>
			);
		if (status === "success")
			return <CheckCircleIcon style={{ color: "green", width: 15, position: "relative", top: -8, right: -14 }} />;
		if (status === "error")
			return (

				<Tooltip
					style={{ position: "relative", top: -8, right: -14 }}
					content={
						errors ? errors.map(({message}) => (message)).join(", ") : "An error occurred"
					}>
					<XCircleIcon style={{ color: "red", width: 15}} />
				</Tooltip>
			)
	}, [connected, status, sending]);

	useEffect(() => {
		if (status !== "pending" || document.hidden) return; // if FPS status is not pending, do not check status
		const interval = setInterval(() => {
			if (status !== "pending") clearInterval(interval);
			getPayPeriodStatus(periodId);
		}, 15000); // Check Submission status every 15 seconds
		if (status !== "pending") clearInterval(interval); // if updated, clear interval

		return () => clearInterval(interval); // if component unmounted, clear interval
	}, [status]);

	const canSend = !sending && (!status || ["error", "warning"].includes(status)) && complete;

	const title = useMemo(() => {
		if (status) return toTitleCase(status);
		if (sending) return "Sending...";
		if (canSend) return `Send to ${integration}`;
		if (!complete) return "Payroll not complete";
	}, [status, complete]);

	if (!connected || !status) return null;
	return (
		<div
			title={title}
			complete={canSend}
			style={{
				padding: 2,
				paddingBottom: 4,
				borderRadius: "50%",
				width: 24.5,
				height: 24.5,
				cursor: canSend ? "pointer" : "not-allowed",
				marginLeft: 10,
			}}
			onClick={() => {
				// if (status === "error") {
				// 	if (functionality?.payroll?.errors) toggleErrorsModal(periodId);
				// 	return;
				// }
				if (canSend) sendPayPeriodToAccountingIntegration(periodId);
			}}
		>
			<img
				src={logo}
				style={{ width: "24.5px" }}
			/>
			{icon}
		</div>
	);
};

const mapStateToProps = (state, { periodId, integration }) => {
	const { [camelCase(integration)]: integrationObject } = { ...state.integration?.accounting };
	const { [camelCase(integration)]: details } = { ...state.integrationDetails?.accounting };

	const { functionality, logo } = details || {};

	const currentPeriod = state.payPeriods?.periods?.find(({ id }) => id === periodId);
	const complete = (() => {
		switch (typeof currentPeriod?.complete) {
			case "boolean":
				return currentPeriod?.complete;
			case "string":
				return !["no", "false"].includes(currentPeriod?.complete);
			case "undefined":
				return !!currentPeriod?.complete;
		}
	})();

	const integrationPeriod = integrationObject?.payPeriods?.find(({ payPeriodId }) => payPeriodId === periodId)

	console.log({integrationPeriod});

	return {
		connected: !!integrationObject,
		status: integrationPeriod?.status,
		sending: integrationObject?.sendingPayroll?.includes(periodId),
		errors: integrationPeriod?.errors,
		logo,
		complete,
		functionality,
	};
};

const mapDispatchToProps = (dispatch, { integration }) => ({
	sendPayPeriodToAccountingIntegration: (periodId) =>
		dispatch(ACCOUNTING_INTEGRATION_ACTIONS.sendPayPeriodToAccountingIntegration(integration, periodId)),
	getPayPeriodStatus: (periodId) => dispatch(ACCOUNTING_INTEGRATION_ACTIONS.checkPayrollStatus(integration, periodId)),
	toggleErrorsModal: (periodId) => dispatch(ACCOUNTING_INTEGRATION_ACTIONS.toggleErrorsModal(integration, periodId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountingIntegrationSendData);
